export const ACTION_POINT_ACCOUNTABLE_CONFLICT =
    'ACTION_POINT_ACCOUNTABLE_CONFLICT';

export const ACTION_POINT_ACCOUNTABLE_CONFLICT_PREVIEW_LIMIT = 10;

export function isActionPointAccountableConflict(response) {
    return (
        response?.success === false &&
        response?.code === ACTION_POINT_ACCOUNTABLE_CONFLICT
    );
}

export function cloneConflictPayload(payload) {
    return JSON.parse(JSON.stringify(payload));
}

export function getDisplayConflicts(
    conflicts,
    limit = ACTION_POINT_ACCOUNTABLE_CONFLICT_PREVIEW_LIMIT
) {
    return Array.isArray(conflicts) ? conflicts.slice(0, limit) : [];
}

export function getHiddenConflictCount(response, displayCount) {
    const affectedCount = Number(response?.affected_count) || 0;
    return Math.max(affectedCount - displayCount, 0);
}

export function getClearedAccountablesCount(response) {
    return Number(response?.meta?.cleared_accountables_count) || 0;
}

export function formatConflictTitle(title) {
    const text = String(title || '').replace(/^\s*-\s*/, '').trim();
    return text || 'Untitled action item';
}
